export const common = {
  options: {
    type: [Array, Object],
    required: true,
    default: () => [],
  },
  value: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: 'Select items...',
  },
  itemLabel: {
    type: String,
    default: 'label',
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  inputId: {
    type: String,
    default: 'vue-multiselect-input',
  },
  labelId: {
    type: String,
    default: 'vue-multiselect-label',
  },
  keyValueFormat: {
    // if we want to pass options in Object format ex.: {'this_is_gonna_be_value': 'this is going to be label'}
    type: Boolean,
    default: false,
  },
};
